import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function reprocessDocument(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_REPROCESS,
    (organisationId, projectId, documentId, lastEdited, contractType) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}/document/${documentId}/reprocess`,
          {
            last_edited: lastEdited,
            contract_type: contractType,
          },
          {withCredentials: true},
        )
        .then(response => ({id: documentId, ...response.data})),
  );
}
